<template>
  <!-- Spodné menu na mobile v štýle iOS tab baru: priesvitná lišta, ikony s popisom, aktívna položka v Ruby. -->
  <nav class="mobile-tabbar" aria-label="Rýchla navigácia" data-shell="tabbar">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="mobile-tabbar__item"
      :class="{ 'is-active': isActive(item) }"
      :aria-current="isActive(item) ? 'page' : undefined"
    >
      <span class="mobile-tabbar__icon">
        <v-icon :icon="item.icon" size="24" />
        <span v-if="item.badge" class="mobile-tabbar__badge">{{ item.badge > 99 ? '99+' : item.badge }}</span>
      </span>
      <span class="mobile-tabbar__label">{{ item.title }}</span>
    </router-link>
  </nav>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useAppNavigation } from '@/composables/useAppNavigation'

export default defineComponent({
  name: 'AppMobileNavigation',

  setup() {
    const route = useRoute()
    const { counts } = useAppNavigation()

    const items = computed(() => [
      { title: 'Prehľad', icon: 'mdi-home', to: '/', exact: true },
      { title: 'Požiadavky', icon: 'mdi-inbox', to: '/poziadavky', badge: counts.requests },
      { title: 'Úlohy', icon: 'mdi-clipboard-check', to: '/ulohy', badge: counts.tasks },
      { title: 'Kalendár', icon: 'mdi-calendar', to: '/kalendar' },
      { title: 'Akcie', icon: 'mdi-bullhorn', to: '/marketing' },
    ])

    const isActive = (item) =>
      item.exact ? route.path === item.to : route.path === item.to || route.path.startsWith(`${item.to}/`)

    return { items, isActive }
  },
})
</script>

<style lang="scss" scoped>
.mobile-tabbar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: stretch;
  justify-content: space-around;
  height: calc(var(--mobile-tabbar-height) + env(safe-area-inset-bottom, 0px));
  padding: 6px 4px env(safe-area-inset-bottom, 0px);
  background: rgba(255, 255, 255, 0.86);
  border-top: 0.5px solid rgba(16, 16, 16, 0.12);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
}

@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .mobile-tabbar {
    background: #ffffff;
  }
}

.mobile-tabbar__item {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 3px;
  min-width: 0;
  padding-top: 2px;
  color: #8a8a8e;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  transition: color var(--duration-fast) ease;

  &.is-active {
    color: var(--brand-ruby);
  }

  &:active .mobile-tabbar__icon {
    transform: scale(0.92);
  }
}

.mobile-tabbar__icon {
  position: relative;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  transition: transform 120ms ease;
}

.mobile-tabbar__badge {
  position: absolute;
  top: -3px;
  left: 18px;
  display: grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--brand-ruby);
  box-shadow: 0 0 0 2px #ffffff;
  color: #ffffff;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1;
}

.mobile-tabbar__label {
  max-width: 100%;
  overflow: hidden;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
